<template>
  <v-container id="create-extarnal-chain">
    <!-- header -->
    <v-row class="mb-6 px-6" justify="center" align="center">
      <v-btn
        id="cancel"
        class="elevation-0 pl-0 pr-3"
        color="black--text grey lighten-2"
        @click="back()"
      >
        <v-icon class="ma-0 pa-0" color="grey darken-3">
          mdi-chevron-left
        </v-icon>
        {{ $t("main.back") }}
      </v-btn>
      <v-col cols="7">
        <span id="filename-text" class="text-h5"> {{ $t('documentSignatureCustomization.content.createChain.setSignatureField.title') }}</span>
      </v-col>

      <v-col class="d-flex flex-row justify-end">
        <v-btn
          v-if="canSign" id="confirm_sign" color="success" :disabled="checkSignButtonDisabled"
          :loading="isUploading" @click="createChain(true)"
        >
          <template v-if="!isApproveMode">
            <v-icon>mdi-draw-pen</v-icon>
            {{ $t('main.sign') }}
          </template>
          <template v-else>
            <v-icon>mdi-check-decagram</v-icon>
            {{ $t('main.continue') }}
          </template>
        </v-btn>
        <v-btn
          v-else
          id="create-chain-button"
          class="mx-4 px-4"
          color="primary"
          :disabled="checkSignButtonDisabled"
          :loading="isUploading"
          @click="createChain(false)"
        >
          <v-icon class="mr-1 ml-0">mdi-plus-circle-outline</v-icon>
          {{ $t("documentSignatureCustomization.title.createChain") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row align="stretch" align-content="space-between">
      <!-- PARTICIPANTS -->
      <v-col sm="12" md="6" align-self="start">
        <v-card id="upload_document_card">
          <v-card-title>{{ $t('documents.content.uploadDocument') }}</v-card-title>
          <v-card-text>
            <v-text-field
              id="upload_document_filename"
              v-model="fileName" disabled
              :label="$t('main.name')"
            ></v-text-field>

            <v-switch
              id="ordered_switch"
              v-model="chosenSignatureType" disabled inset color="blue darken-2"
              :false-value="types.UNORDERED" :true-value="types.ORDERED" :label="chosenSignatureType === types.UNORDERED
                ? $t('documentSignatureCustomization.content.createChain.chainType.unorderedDescription')
                : $t('documentSignatureCustomization.content.createChain.chainType.orderedDescription')"
              prepend-icon="mdi-graph-outline" @click="_computedWatchers.canSign.run()"
            >
            </v-switch>
            <v-switch
              v-if="signingTrailEnabled"
              id="signingtrail_switch" v-model="useSigningTrail" disabled
              color="blue darken-2" :label="useSigningTrail
                ? $t('documentSignatureCustomization.content.createChain.useSigningTrail.true')
                : $t('documentSignatureCustomization.content.createChain.useSigningTrail.false')"
              prepend-icon="mdi-file-certificate-outline" inset
            >
            </v-switch>
            <v-row v-if="signingTrailEnabled && useSigningTrail " align="center">
              <v-col cols="1" />
              <v-col>
                <v-radio-group v-model="attachedOrDetachedSigningTrail" disabled class="pt-0 mt-0" row>
                  <v-radio
                    id="radio_attached" color="blue darken-2"
                    :label="$t('documentSignatureCustomization.content.createChain.useSigningTrail.signingTrailMode.ATTACHED')"
                    value="ATTACHED"
                  />
                  <v-radio
                    id="radio_detached" color="blue darken-2"
                    :label="$t('documentSignatureCustomization.content.createChain.useSigningTrail.signingTrailMode.DETACHED')"
                    value="DETACHED"
                  />
                </v-radio-group>
              </v-col>
            </v-row>

            <v-data-table
              id="virtual-scroll-table" ref="dtable" :headers="headers" :items="addedUsers"
              item-key="uniqueId" :items-per-page="-1" :no-data-text="$t('dataTable.content.noDataAvailable')"
              hide-default-footer dense class="mb-2"
            >
              <template #body="props">
                <tbody>
                  <tr
                    v-for="(user, index) in props.items"
                    :key="index" @click="userSelected(user,index)"
                  >
                    <td>
                      <span>{{ getRank(user) }}</span>
                    </td>
                    <td>
                      <long-text :text="getFullName(user)">
                      </long-text>
                    </td>
                    <td>
                      <span id="user_email" class="caption">
                        &lt;<long-text :text="user.email" :max-char="29">
                        </long-text>&gt;
                      </span>
                    </td>
                    <td>
                      <v-tooltip bottom>
                        <template #activator="{ on, attrs }">
                          <v-btn
                            id="toggle_user_role" v-bind="attrs" icon
                            disabled v-on="on"
                            @click="user.role = getToggledUserRole(user)"
                          >
                            <v-icon>
                              {{ getToggledUserRoleIcon(user.role) }}
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ getRoleTooltipText(user.role) }}</span>
                      </v-tooltip>
                    </td>
                    <td align="right">
                      <v-row>
                        <v-spacer></v-spacer>

                        <!-- Menu for setting Subsigner -->
                        <v-menu v-model="subsignerNameMenuVisible" offset-y :close-on-content-click="false">
                          <template #activator="{ on, attrs }">
                            <v-btn
                              v-show="user.role === memberRole.CLERK" id="set_subsigner_button" text class="pa-0"
                              v-bind="attrs" v-on="on" @click="() => {

                                if (user.subsignerName) { subsignerName = user.subsignerName }
                              }"
                            >
                              <v-icon>mdi-account-supervisor</v-icon>
                              {{ user.subsignerName ? $t('dataTable.content.action.changeSubsigner') :
                                $t('dataTable.content.action.setSubsigner') }}
                            </v-btn>
                          </template>

                          <v-card id="subsigner_card" class="pa-2">
                            <v-card-subtitle class="subtitle-1">
                              {{ $t('dataTable.content.action.setSubsignerDescription') }}
                            </v-card-subtitle>
                            <v-card-text>
                              <v-form @submit.prevent="setSubsigner(index, user)">
                                <v-text-field
                                  id="subsigner_input" ref="subsignerInput" v-model="subsignerName" clearable
                                  dense hide-details autofocus label="Subsigner Name"
                                  @keyup.enter="setSubsigner(index, user)"
                                />
                                <v-btn
                                  id="save_subsigner" class="mt-2" color="primary"
                                  @click="setSubsigner(index, user)"
                                >
                                  <v-icon>mdi-check-circle-outline</v-icon>
                                  {{ $t('main.save') }}
                                </v-btn>
                              </v-form>
                            </v-card-text>
                          </v-card>
                        </v-menu>

                        <template v-if="user.role !== 'VIEWER' && user.role !== 'APPROVER' ">
                          <template v-if="selectedUserIndex === index ">
                            <v-btn
                              id="save_position_button"
                              :loading="dragging"
                              :color="user.positionSaved ? 'success' : undefined"
                              @click="setSignatureField"
                            >
                              <v-icon>
                                {{ user.positionSaved ? 'mdi-check-circle-outline' : 'mdi-border-radius' }}
                              </v-icon>
                              {{ user.positionSaved
                                ? $t('documentSignatureCustomization.content.createChain.setSignatureField.savedPosition')
                                : $t('documentSignatureCustomization.content.createChain.setSignatureField.setPostition')
                              }}
                            </v-btn>
                          </template>
                          <template v-else>
                            <v-chip v-if="!!user.savedSignatureFieldParameters" color="success">
                              {{ $t('documentSignatureCustomization.content.createChain.setSignatureField.savedPosition') }}
                            </v-chip>
                            <v-chip v-else>
                              {{ $t('documentSignatureCustomization.content.createChain.setSignatureField.missingPosition') }}
                            </v-chip>
                          </template>
                        </template>

                      <!-- <v-btn text color="error" @click="removeUser(user, index)">
                          <v-icon>mdi-account-remove</v-icon>
                          {{ $t('dataTable.content.action.removeUser') }}
                        </v-btn> -->

                      <!-- <v-icon>mdi-drag-vertical</v-icon> -->
                      </v-row>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>

            <!-- <v-autocomplete
              id="autocomplete_input" :key="autocompleteKey" v-model="nextUserToAdd" :items="enabledUsers"
              item-text="email" item-value="id" return-object
              :label="$t('documentSignatureCustomization.content.createChain.recipient') + `*`"
              :placeholder="$t('autocomplete.startTyping')" prepend-inner-icon="mdi-fountain-pen-tip"
              :no-data-text="noDatatext" clearable outlined hide-details dense :search-input="search"
              @update:search-input="listEnabledUsersWatcher" @keydown.enter="addUser" @click.prevent="addUser"
            >
              <template slot="item" slot-scope="{ item }">
                <v-row align-content="center" @mouseup="addUser(item)">
                  <span class="body-2 py-4">{{ item.firstName }} {{ item.lastName }} <span
                    v-if="!!item.email"
                    class="caption"
                  >&lt;{{ item.email }}&gt; </span></span>
                  <v-spacer></v-spacer>
                </v-row>
              </template>
              <template v-if="!userGroupsEnabled && !enabledUsers.length && displayInviteButton" #no-data>
                <v-row>
                  <v-col class="ml-3">
                    <v-label class="ml-6">{{ noDatatext }}</v-label>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn id="invite_user" class="ml-3" color="primary" @click="addUserAsInvite()">
                      {{
                        $t('documentSignatureCustomization.content.createChain.iniviteUserButton') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </template>
            </v-autocomplete> -->
            <!-- <v-btn
              id="add_me" color="transparent" tile class="pl-0 pr-1 mt-2 rounded-l-xl modalButton" :ripple="false"
              :disabled="!currentUser.roles.includes('signer')" @click="addMe()"
            >
              <v-icon large class="modalButton">
                mdi-plus-circle
              </v-icon>
              {{ $t('documentSignatureCustomization.content.createChain.addme') }}
            </v-btn>
            <v-divider
              class="my-6"
            ></v-divider>-->
            <v-text-field
              v-if="creatorComment"
              id="comment_text_field"
              v-model="creatorComment"
              prepend-icon="mdi-comment modalButtonColor--text large"
              persistent-hint
              disabled
            >
              <template #label>
                <span class="text--secondary">{{ $t('documentSignatureCustomization.comments.label') }}</span>
              </template>
            </v-text-field>
          </v-card-text>
        </v-card>
      </v-col>
      <!--  PDF -->
      <v-col sm="12" md="6">
        <v-overlay :absolute="true" :value="isUploading">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
          ></v-progress-circular>
        </v-overlay>
        <visibleSignature
          ref="visibleSignature"
          :doc-data="documentBase64"
          :sign-prof="placeholder"
          :pdf-encrypted.sync="pdfEncrypted"
          @updatedSignProf="updatedSignatureProfile"
          @pdfLoaded="pdfLoaded"
          @sizingFinished="dragging = false"
          @draggingFinished="dragging = false"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LongText from '@/components/LongText.vue'
import VisibleSignature from '@/components/VisibleSignature'
import { showToastError, showToastSuccess } from '@/event-bus'
import users from '@/services/api/users'
import debounce from 'lodash.debounce'
import memberRole from './memberRole.js'

import documents from '../../../services/api/documents.js'
import signatureChains from '../../../services/api/signatureChains.js'
import signatures from '../../../services/api/signatures.js'
import SignatureChainStatus from './SignatureChainStatus.js'
import signatureChainType from './SignatureChainType'

import placeholderImg from '@/assets/other/signature_placeholder.png'

export default {
  components: {
    VisibleSignature,
    LongText

  },
  data() {
    return {
      placeholder: {
        savedSignatureFieldParameters: {
          originX: 0,
          originY: 0,
          width: 300,
          height: 100,
          page: 1
        },
        sourceImageDataUrl: ''
      },
      search: '',
      autocompleteKey: 1,

      memberRole: memberRole,
      documentBase64: '',
      document: {},
      isUploading: true,
      enabledUsers: [],
      addedUsers: [],
      chosenSignatureType: 'UNORDERED',
      nextUserToAdd: {},
      useSigningTrail: true,
      signingTrailEnabled: this.$store.state.remoteConfig.signingTrailEnabled,
      attachedOrDetachedSigningTrail: 'ATTACHED',

      types: { ...signatureChainType }, // only needed for template
      headers: [
        {
          text: this.$t('dataTable.header.users.rank'),
          sortable: false,
          align: 'left',
          value: 'rank',
          width: '5%'
        },
        {
          text: this.$t('dataTable.header.users.name'),
          align: 'left',
          value: 'name'
        },
        {
          text: this.$t('dataTable.header.users.email'),
          align: 'left',
          value: 'email'
        },
        {
          text: this.$t(
            'documentSignatureCustomization.content.createChain.role.header'
          ),
          align: 'left',
          value: 'role',
          width: '1%'
        },
        {
          text: this.$t('dataTable.header.actions'),
          align: 'right',
          value: 'actions',
          sortable: false
        }
      ],
      noDatatext: this.$t('autocomplete.startTyping'),
      userGroupsEnabled: this.$store.state.remoteConfig
        ? this.$store.state.remoteConfig.userGroupsEnabled
        : false,
      displayInviteButton: false,
      subsignerName: '',
      enabledUsersFixed: [],
      subsignerNameMenuVisible: false,
      pdfEncrypted: false,
      fileName: '',
      creatorComment: '',
      selectedUserIndex: 0,
      position: {
        originX: 0,
        originY: 0,
        width: 300,
        height: 100,
        page: 1
      },
      dragging: false,
      saved: false
    }
  },

  computed: {
    currentUser() {
      return this.$store.state.currentUser
    },
    checkSignButtonDisabled() {
      const d =
        this.addedUsers.length === 0 ||
        this.addedUsers.every((x) => x.role === memberRole.VIEWER)
      return d
    },
    clerkEnabled() {
      return this.$store.state.remoteConfig.clerkEnabled
    },
    documentId() {
      return this.$route.params.docId
    },
    canSign() {
      const hasAddedUsers = this.addedUsers.length > 0

      const isCurrentUserFirst =
        hasAddedUsers &&
        this.addedUsers[0].id === this.$store.state.currentUser.id
      const isUnorderedWithHimself =
        this.chosenSignatureType === signatureChainType.UNORDERED && this.includesHimself

      return hasAddedUsers && (isCurrentUserFirst || isUnorderedWithHimself)
    },
    isApproveMode() {
      const isCurrentUserFirstApprover =
        (this.addedUsers[0].role === memberRole.APPROVER) && this.chosenSignatureType === signatureChainType.ORDERED

      const isUnorderedCurrentUserApprover =
        this.chosenSignatureType === signatureChainType.UNORDERED &&
        this.includesHimself &&
        this.addedUsers.some(user => user.id === this.currentUser.id && user.role === memberRole.APPROVER)

      return isCurrentUserFirstApprover || isUnorderedCurrentUserApprover
    },

    includesHimself() {
      const currentUserId = this.$store.state.currentUser?.id
      return this.addedUsers.some(user => user.id === currentUserId)
    }

  },
  async mounted() {
    await this.getDocument()
    await this.listEnabledUsersWatcher()
    const pageReq = {
      maxResults: 100
    }
    const resp = await users.listEnabledUsers('', pageReq)
    this.enabledUsersFixed = resp.items

    this.loadSignatureChainRequest()
  },
  methods: {
    setSignatureField() {
      this.addedUsers[this.selectedUserIndex].savedSignatureFieldParameters = this.position
      this.$nextTick(() => {
        this.$set(this.addedUsers[this.selectedUserIndex], 'positionSaved', true)
      })
    },
    updatedSignatureProfile(e) {
      this.dragging = true
      this.$nextTick(() => {
        this.$set(this.addedUsers[this.selectedUserIndex], 'positionSaved', false)
      })

      this.position = {
        originX: e.savedSignatureFieldParameters.originX,
        originY: e.savedSignatureFieldParameters.originY,
        width: e.savedSignatureFieldParameters.width,
        height: e.savedSignatureFieldParameters.height,
        page: e.savedSignatureFieldParameters.page
      }
    },
    userSelected(user, idx) {
      this.selectedUserIndex = idx

      const params = user.savedSignatureFieldParameters

      if (params) {
        this.placeholder.savedSignatureFieldParameters = { ...params }
        this.$nextTick(() => {
          this.$refs.visibleSignature?.updateSignatureProfile(this.placeholder)
        })
      }
    },
    loadSignatureChainRequest() {
      const req = this.$store.state.currentChain
      this.chosenSignatureType = req.type
      this.addedUsers = req.addedUsers
      this.fileName = req.fileName || this.document.fileName
      this.creatorComment = req.comment
      this.useSigningTrail = req.useSigningTrail
      this.attachedOrDetachedSigningTrail = req.attachedOrDetachedSigningTrail
    },
    async pdfLoaded() {
      this.placeholder = {
        sourceImageDataUrl: await this.imageFileToBase64()

      }
      this.isUploading = false
    },
    async imageFileToBase64() {
      try {
        const response = await fetch(placeholderImg)

        const imageBlob = await response.blob()

        return await new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => resolve(reader.result)
          reader.onerror = error => reject(error)
          reader.readAsDataURL(imageBlob)
        })
      } catch (error) {
        console.error(error)
        throw error
      }
    },

    async getDocument() {
      this.isUploading = true
      try {
        const blob = await documents.downloadDocument(this.documentId)
        const base64 = await this.blobToBase64(blob)
        const docuDto = await documents.getDocument(this.documentId)
        this.document = docuDto
        this.pdfEncrypted = (docuDto.security === 'ENCRYPTED_WITH_OWNER_PASSWORD') || (docuDto.security === 'ENCRYPTED_WITH_USER_PASSWORD')
        this.documentBase64 = base64.split(',')[1]
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      } finally {
        this.isUploading = false
      }
    },
    blobToBase64(blob) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.readAsDataURL(blob)
      })
    },

    listEnabledUsersWatcher: debounce(function(search) {
      this.listEnabledUsers(search)
    }, 500),

    async listEnabledUsers(searchUser) {
      const pageReq = {
        maxResults: 5
      }
      let searchUserlen = 0
      try {
        searchUserlen = searchUser.length
      } catch (err) {}
      if (searchUserlen > 0) {
        try {
          const resp = await users.listEnabledUsers(searchUser, pageReq)
          this.enabledUsers = resp.items

          if (resp.items.length === 0) {
            this.noDatatext = this.$t(
              'documentSignatureCustomization.content.createChain.userNotFound'
            )

            if (this.isValidEmail(searchUser)) {
              this.invitableUserEmail = searchUser
              this.displayInviteButton = true
            } else {
              this.displayInviteButton = false
            }
          } else {
            this.displayInviteButton = false
          }
        } catch (error) {
          const errorMsg = this.getErrorMessage(error)
          showToastError(errorMsg)
        }
      } else {
        this.noDatatext = this.$t('autocomplete.startTyping')
      }
    },

    addUser(user) {
      if (user.id === this.currentUser.id) {
        user.role = memberRole.CREATOR_AND_SIGNER
      } else {
        user.role = memberRole.SIGNER
      }

      this.nextUserToAdd = user

      // we need to copy the object and assign a unique id for it to avoud Vue duplicate key warnings
      this.nextUserToAdd = Object.assign({}, this.nextUserToAdd)
      this.nextUserToAdd.uniqueId = this.addedUsers.length + 1
      // explanation: somehow a empty array is not an array: error: .include is  not a function
      if (this.nextUserToAdd !== undefined && this.nextUserToAdd.email) {
        this.addedUsers.push(this.nextUserToAdd)
        // this.$set(this.addedUsers, this.addedUsers.length - 1, this.nextUserToAdd)

        this.nextUserToAdd = ''
        this.search = ''
        this.autocompleteKey++ // hack: this needs to Vue clear the autocomplete field correctly
      }
      const container = this.$refs.dtable.$el
      container.scrollTop = container.scrollHeight - 1
    },
    addMe() {
      this.addUser(this.currentUser)
    },
    getRank(user) {
      if (
        this.chosenSignatureType === signatureChainType.UNORDERED ||
        user.role === memberRole.VIEWER
      ) {
        return '•'
      } else {
        const signers = this.addedUsers.filter(
          (x) => x.role !== memberRole.VIEWER
        )
        const index = signers.findIndex((x) => x.uniqueId === user.uniqueId)

        return index + 1
      }
    },
    getFullName(user) {
      if (user.firstName && user.lastName) {
        return `${user.firstName} ${user.lastName}`
      } else if (user.firstName) {
        return `${user.firstName}`
      } else if (user.lastName) {
        return `${user.lastName}`
      } else return ''
    },
    getToggledUserRole(user) {
      const { role } = user

      const userHaveRoles = user.roles
      const userHaveApprover = userHaveRoles && user.roles.includes('approver')
      const userHaveSign = userHaveRoles && user.roles.includes('signer')
      const canAddApprover = userHaveApprover
      const canAddSigner = !userHaveRoles || userHaveSign
      const canAddViewer = userHaveRoles
      const canAddClerk = this.clerkEnabled && (!userHaveRoles || userHaveSign)
      if (user.id === this.currentUser.id) {
        /* switch (role) {
          case memberRole.CREATOR_AND_SIGNER:
            return this.clerkEnabled ? memberRole.CLERK : memberRole.APPROVER
          case memberRole.APPROVER:
            return this.clerkEnabled ? memberRole.CLERK : memberRole.CREATOR_AND_SIGNER
          case memberRole.CLERK:
            return memberRole.CREATOR_AND_SIGNER
          default:
            return role
        } */
        switch (role) {
          case memberRole.CREATOR_AND_SIGNER:
            return this.clerkEnabled ? memberRole.CLERK : (canAddApprover ? memberRole.APPROVER : memberRole.VIEWER)
          case memberRole.CLERK:
            return this.clerkEnabled ? (canAddApprover ? memberRole.APPROVER : memberRole.VIEWER) : memberRole.VIEWER
          case memberRole.VIEWER:
            return canAddApprover ? memberRole.APPROVER : memberRole.CREATOR_AND_SIGNER
          case memberRole.APPROVER:
            return memberRole.CREATOR_AND_SIGNER
          default:
            return role
        }
      } else {
        const rolesOrder = [
          this.memberRole.SIGNER,
          this.memberRole.CLERK,
          this.memberRole.VIEWER,
          this.memberRole.APPROVER
        ]
        const canAddMap = {
          [this.memberRole.SIGNER]: canAddSigner,
          [this.memberRole.CLERK]: canAddClerk,
          [this.memberRole.VIEWER]: canAddViewer,
          [this.memberRole.APPROVER]: canAddApprover
        }

        const currentIndex = rolesOrder.indexOf(role)
        const totalRoles = rolesOrder.length

        for (let i = 1; i <= totalRoles; i++) {
          const nextIndex = (currentIndex + i) % totalRoles
          const nextRole = rolesOrder[nextIndex]

          if (canAddMap[nextRole]) {
            return nextRole
          }
        }
        console.error('Unknown role for non-current user', role)
        return role
      }
    },
    getToggledUserRoleIcon(role) {
      switch (role) {
        case memberRole.CREATOR:
          return 'mdi-file-sign'
        case memberRole.SIGNER:
          return 'mdi-file-sign'
        case memberRole.CREATOR_AND_SIGNER:
          return 'mdi-file-sign'
        case memberRole.VIEWER:
          return 'mdi-eye-outline'
        case memberRole.CLERK:
          return 'mdi-account-tie'
        case memberRole.APPROVER:
          return 'mdi-check-decagram'
        default:
          console.error('Unknown role')
      }
    },

    getRoleTooltipText(role) {
      switch (role) {
        case memberRole.CREATOR_AND_SIGNER:
          return this.$t(
            'documentSignatureCustomization.content.createChain.role.creatorExplainer'
          )
        case memberRole.SIGNER:
          return this.$t(
            'documentSignatureCustomization.content.createChain.role.signerExplainer'
          )
        case memberRole.VIEWER:
          return this.$t(
            'documentSignatureCustomization.content.createChain.role.viewerExplainer'
          )
        case memberRole.CLERK:
          return this.$t(
            'documentSignatureCustomization.content.createChain.role.clerkExplainer'
          )
        case memberRole.APPROVER:
          return this.$t('signatureChains.states.approverExplainer')
        default:
          console.error('Unknown role')
          break
      }
    },
    removeUser(user, index) {
      this.addedUsers.splice(index, 1)
    },
    async createChain(sign = false) {
      const req = {
        type: this.chosenSignatureType,
        origDocId: this.documentId,
        signers: [],
        viewerEmails: this.addedUsers
          .filter(user => user.role === memberRole.VIEWER || user.role === memberRole.CREATOR)
          .map(user => user.email),
        comment: this.creatorComment.length > 0 ? this.creatorComment : null,
        signingTrailMode: this.signingTrailEnabled
          ? (this.useSigningTrail ? this.attachedOrDetachedSigningTrail : 'NONE')
          : 'NONE'
      }

      this.addedUsers.forEach(user => {
        if (
          user.role === memberRole.SIGNER ||
      user.role === memberRole.CREATOR_AND_SIGNER ||
      user.role === memberRole.APPROVER ||
      (this.clerkEnabled && user.role === memberRole.CLERK)
        ) {
          const signer = {
            email: user.email,
            clerkMode: user.role === memberRole.CLERK,
            approver: user.role === memberRole.APPROVER,
            subsignerName: user.subsignerName || undefined
          }

          if (user.savedSignatureFieldParameters && user.role !== memberRole.APPROVER) {
            signer.signatureFieldParameters = user.savedSignatureFieldParameters
          }

          req.signers.push(signer)
        }
      })

      this.isUploading = true
      try {
        const chain = await signatureChains.createSignatureChain(req)
        this.handleSignatureNavigation(chain)
      } catch (error) {
        console.error(error)
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      } finally {
        this.isUploading = false
      }
    },

    handleSignatureNavigation(chain) {
      if (!this.includesHimself) {
        this.$router.push({ name: 'SignatureChains' })
        showToastSuccess(this.$t('toastMessage.succesfullyCreated'))
        return
      }

      const currentUserId = this.$store.state.currentUser.id

      if (chain.type === signatureChainType.ORDERED) {
        const firstSignature = chain.signatures[0]
        if (firstSignature.user.id !== currentUserId) {
          this.$router.push({ name: 'SignatureChains' })
          showToastSuccess(this.$t('toastMessage.succesfullyCreated'))
          return
        }
      }

      const userSignature = chain.signatures.find(sig => sig.user?.id === currentUserId)
      if (!userSignature) {
        this.$router.push({ name: 'SignatureChains' })
        showToastSuccess(this.$t('toastMessage.succesfullyCreated'))
        return
      }

      const signId = userSignature.id
      const currentSignatureId = this.getCurrentSignatureId(chain)
      const latestSigned = chain.signatures.findLast(sig => sig.signedDocument)
      const docIdToSign = latestSigned ? latestSigned.signedDocument.id : chain.origDocument.id

      const fieldParams = userSignature.signatureFieldParameters
      const query = (fieldParams?.originX != null && fieldParams?.originY != null && fieldParams?.page != null)
        ? {
          originX: fieldParams.originX,
          originY: fieldParams.originY,
          page: fieldParams.page,
          width: fieldParams.width,
          height: fieldParams.height
        }
        : {}

      // Eldöntjük, hova navigáljunk

      if (userSignature.approver) {
        this.navigateToApprove(chain, signId, currentSignatureId, docIdToSign)
      } else if (userSignature.clerkMode) {
        this.navigateToClerk(chain, signId, currentSignatureId, docIdToSign, query)
      } else {
        this.navigateToSign(chain, signId, currentSignatureId, docIdToSign, query)
      }
    },
    navigateToSign(chain, signId, currentSignatureId, docIdToSign, query) {
      this.$store.commit('setChainsToSign', [chain])
      this.$router.push({
        path: `/document/${chain.id}/${docIdToSign}/customization/signature/${signId}/${currentSignatureId}`,
        query
      })
    },
    navigateToClerk(chain, signId, currentSignatureId, docIdToSign, query) {
      this.$store.commit('setCurrentChain', chain)
      this.$router.push({
        path: `/document/${docIdToSign}/clerk/${signId}/${currentSignatureId}`,
        query
      })
    },
    navigateToApprove(chain, signId, currentSignatureId, docIdToSign) {
      this.$store.commit('setCurrentChain', chain)
      this.$router.push({
        path: `/document/${docIdToSign}/approve-customization/${signId}/${currentSignatureId}`
      })
    },

    getUserSignatureId(item) {
      const userSignature = item.signatures.find(
        (signature) =>
          signature.user.id === this.currentUser.id &&
          signature.status === SignatureChainStatus.CREATED
      )
      return userSignature.id
    },
    getUserSignatureIdForApprover(item) {
      const userSignature = item.signatures.find(signature => (!!signature.user && signature.user.id === this.currentUser.id && signature.status === SignatureChainStatus.CREATED && signature.approver === true))
      return userSignature.id
    },
    getUserSignatureIdForClerk(item) {
      const userSignature = item.signatures.find(signature => (!!signature.user && signature.user.id === this.currentUser.id && signature.status === SignatureChainStatus.CREATED && signature.clerkMode === true))
      return userSignature.id
    },

    getCurrentSignatureId(item) {
      let currentSignatureId = '/'
      if (item.type === signatureChainType.ORDERED) {
        currentSignatureId = ''
      } else {
        if (item.currentSignatureId === undefined) {
          currentSignatureId = ''
        } else {
          currentSignatureId += item.currentSignatureId
        }
      }

      return currentSignatureId
    },
    setSubsigner(index, user) {
      if (this.subsignerName.trim()) {
        this.addedUsers[index].subsignerName = this.subsignerName
        this.subsignerNameMenuVisible = false // Close the menu
      } else {
      }
    },
    isValidEmail(email) {
      // Regular expression for validating an email address
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(email)
    },
    addUserAsInvite() {
      const invitableUser = {}
      invitableUser.roles = []
      invitableUser.roles.push('signer')
      invitableUser.email = this.invitableUserEmail
      this.addUser(invitableUser)
    },

    isUserDisabledForRoleChange(user) {
      const isEmailInArray = this.enabledUsersFixed.some(item => item.email === user.email)
      return !isEmailInArray || (user.roles && !user.roles.includes('signer'))
    },
    async back() {
      this.$store.commit('removeCurrentChain')
      await documents.deleteDocument(this.documentId)
      this.$router.back()
    }

  }
}
</script>

<style scoped>
#virtual-scroll-table {
  max-height: 20vh;
  overflow-y: auto;
  overflow-x: hidden !important;
}
</style>
